import AddFixtureModal from '../add-fixture-modal/index.vue';

export default {
    name: 'AddFixtureButton',

    methods: {
        addFixture() {
            this.$ionic.modalController.create({
                component: AddFixtureModal
            }).then(m => m.present());
        }
    }
};